export const getElementWidths = (tabContainer) => {
  const tabElements = tabContainer.children;

  const moreButtonWidth = tabElements[tabElements.length - 1].clientWidth;

  // pull out each element width
  const widths = [];
  let totalElementWidth = 0;
  tabElements.forEach((t) => {
    widths.push(t.clientWidth);
    totalElementWidth += t.clientWidth;
  });
  return {
    widths,
    totalElementWidth,
    moreButtonWidth,
  };
};

export const getVisibileQuantity = ({ tabContainer, widths, totalElementWidth, moreButtonWidth }) => {
  let buffer = 30;
  if (getComputedStyle) {
    const s = getComputedStyle(tabContainer);
    // eslint-disable-next-line max-len
    buffer = parseInt(s.paddingLeft, 10) + parseInt(s.paddingRight, 10) + parseInt(s.marginLeft, 10) + parseInt(s.marginRight, 10);
  }

  const allowedWidth = tabContainer.clientWidth - buffer;

  if (allowedWidth <= totalElementWidth - moreButtonWidth) {
    let runningWidth = 0;
    let visibleQty = 0;
    while (visibleQty < widths.length) {
      // Will need a more button
      // add widths of each tab until we run out of space
      const nextTabWidth = widths[visibleQty];
      const newTotal = nextTabWidth + runningWidth;
      if (newTotal < (allowedWidth - moreButtonWidth)) {
        runningWidth += nextTabWidth;
        visibleQty += 1;
      } else {
        break;
      }
    }
    return visibleQty;
  }
  return widths.length;
};
